module.exports = __webpack_public_path__ + "img/partner07.ddf4eab3.png";